import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { Widget, WidgetGroup } from '../../shared/models/widget';
import * as _ from 'lodash-es';

@Component({
  selector: 'app-widgets-toolbar',
  templateUrl: './widgets-toolbar.component.html',
  styleUrls: ['./widgets-toolbar.component.scss'],
})
export class WidgetsToolbarComponent implements OnInit, OnChanges {
  @Input() widgets: WidgetGroup[][] = [];
  @Input() colour: string;
  @Input() layout: Widget[];
  @Output() addWidget = new EventEmitter<WidgetGroup>();
  @Output() lockToggled = new EventEmitter<boolean>();
  @Output() removeAllWidgets = new EventEmitter<null>();

  canMoveAndResize = false;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes): void {
    if (changes.widgets && changes.widgets.currentValue) {
      this.widgets = changes.widgets.currentValue;
    }
  }

  addItem(widgetGroup: WidgetGroup) {
    console.info('ADDITEM:', widgetGroup);
    this.addWidget.emit(_.cloneDeep(widgetGroup));
  }

  toggleLock() {
    this.canMoveAndResize = !this.canMoveAndResize;
    this.lockToggled.emit(this.canMoveAndResize);
  }

  btnRemoveAllWidgets() {
    this.removeAllWidgets.emit();
  }
}
